import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { List } from 'antd'

import './perks.less'

import SpinLoader from '../../helpers/SpinLoader'
import PerkItem from './components/PerkItem'
import { callApi, TApiResponse } from '../../../context/api'
import { TPerk } from '../../../context/types'
import { useAuthContext } from '../../../context/auth'

export default function Perks() {
	const { auth } = useAuthContext()
	const [loading, setLoading] = useState<boolean>(true)
	const [perks, setPerks] = useState<TPerk[]>([])
	const [filteredPerks, setFilteredPerks] = useState<TPerk[]>([])

	const fetchPerks = async () => {
		setLoading(true)

		const perksResponse: TApiResponse = await callApi('perks', {
			method: 'GET',
		})

		const { data } = perksResponse.payload

		if (perksResponse.ok) {
			setPerks(data.perks)
		}

		setLoading(false)
	}
	const filterPerks = () => {
		const isExpert = auth?.user?.isExpert
		const perksForUsers = perks.filter(({ available_for_users }) => !!available_for_users)

		if (isExpert) {
			setFilteredPerks(perks)
		} else {
			setFilteredPerks(perksForUsers)
		}
	}
	const getPerks = useCallback(fetchPerks, [perks])
	useEffect(() => {
		getPerks()
	}, [])

	useMemo(() => {
		filterPerks()
	}, [perks])

	return (
		<SpinLoader loading={!!loading}>
			<List
				className="perks-row-container"
				grid={{
					gutter: 15,
					xs: 2,
					sm: 3,
					md: 4,
					lg: 5,
					xl: 6,
					xxl: 6,
				}}
				dataSource={filteredPerks}
				renderItem={(item) => (
					<List.Item>
						<PerkItem perk={item} />
					</List.Item>
				)}
			/>
		</SpinLoader>
	)
}
